export const paths = {
  index: '/',
  top: '/top',
  accounts: {
    mypage: '/accounts/mypage',
    availableDates: '/accounts/available_dates',
    delete: '/accounts/delete',
    identity: {
      index: '/accounts/identity',
      precaution: {
        japaneseNationality: '/accounts/identity/precaution/japanese-nationality',
        foreignNationality: '/accounts/identity/precaution/foreign-nationality',
      },
      form: {
        index: '/accounts/identity/form',
        japaneseNationality: '/accounts/identity/form/japanese-nationality',
        foreignNationality: '/accounts/identity/form/foreign-nationality',
      },
    },
    applications: {
      history: '/accounts/applications/history',
    },
    bank: {
      form: '/accounts/bank/form',
      summary: '/accounts/bank/summary',
      transfers: '/accounts/bank/transfers',
    },
    profile: '/accounts/profile',
    license_certificates: {
      index: '/accounts/license_certificates',
      form: {
        upload_image: '/accounts/license_certificates/form/upload_image',
        request_verification: '/accounts/license_certificates/form/request_verification',
      },
    },
    preparations_to_apply: '/accounts/preparations_to_apply',
    penalties: {
      index: '/accounts/penalties',
      histories: '/accounts/penalties/histories',
      remit: '/accounts/penalties/remit',
    },
    registration: {
      start: '/accounts/registration/start',
      done: '/accounts/registration/done',
      licenses: {
        index: '/accounts/registration/licenses',
        form: '/accounts/registration/licenses/form',
      },
      license_certificates: {
        index: '/accounts/registration/license_certificates',
        form: {
          upload_image: '/accounts/registration/license_certificates/form/upload_image',
          request_verification: '/accounts/registration/license_certificates/form/request_verification',
        },
      },
      identity: {
        index: '/accounts/registration/identity',
        precaution: {
          japaneseNationality: '/accounts/registration/identity/precaution/japanese-nationality',
          foreignNationality: '/accounts/registration/identity/precaution/foreign-nationality',
        },
        form: {
          index: '/accounts/registration/identity/form',
          japaneseNationality: '/accounts/registration/identity/form/japanese-nationality',
          foreignNationality: '/accounts/registration/identity/form/foreign-nationality',
        },
      },
      identityAndContact: {
        index: '/accounts/registration/identity_and_contact',
      },
      bank: {
        form: '/accounts/registration/bank/form',
        summary: '/accounts/registration/bank/summary',
        transfers: '/accounts/registration/bank/transfers',
      },
      incentives: {
        index: '/accounts/registration/incentives',
        histories: '/accounts/registration/incentives/histories',
        exchange: {
          amazonGiftCard: '/accounts/registration/incentives/exchange/amazon-gift-card',
        },
      },
      profile: '/accounts/registration/profile',
      emergencyContact: '/accounts/registration/emergency_contact',
      preparations_to_apply: '/accounts/registration/preparations_to_apply',
      penalties: {
        index: '/accounts/registration/penalties',
        histories: '/accounts/registration/penalties/histories',
      },
    },
    incentives: {
      index: '/accounts/incentives',
      histories: '/accounts/incentives/histories',
      exchange: {
        amazonGiftCard: '/accounts/incentives/exchange/amazon-gift-card',
      },
    },
    emergencyContact: '/accounts/emergency_contact',
    favoriteRecruitments: '/accounts/favorite_recruitments',
    reviewsFromFacilities: '/accounts/reviews_from_facilities',
    statementOfEarning: '/accounts/statement_of_earnings',
  },
  application: {
    done: '/application/done',
    form: '/application/form',
    schedule: '/application/schedule',
  },
  api: {
    login: '/api/login',
    logout: '/api/logout',
  },
  applications: '/applications',
  attendances: {
    index: '/attendances',
    wageWithoutAdjustment: (applicationId: string) => `/attendances/${applicationId}/wage_without_adjustment`,
    wageWithAdjustment: (applicationId: string) => `/attendances/${applicationId}/wage_with_adjustment`,
    review: (applicationId: string) => `/attendances/${applicationId}/review`,
    longTermLaborSurvey: (applicationId: string) => `/attendances/${applicationId}/long_term_labor_survey`,
    favorite: (applicationId: string) => `/attendances/${applicationId}/favorite`,
    cancellation: {
      policy: (applicationId: string) => `/attendances/${applicationId}/cancellation/policy`,
      form: (applicationId: string) => `/attendances/${applicationId}/cancellation/form`,
    },
  },
  chat: '/chat',
  recruitments: {
    index: '/recruitments',
    id: (recruitmentId: string) => `/recruitments/${recruitmentId}`,
    check: {
      application: (recruitmentId: string) => `/recruitments/${recruitmentId}/check/application`,
      belonging: (recruitmentId: string) => `/recruitments/${recruitmentId}/check/belonging`,
      tasks: (recruitmentId: string) => `/recruitments/${recruitmentId}/check/tasks`,
      cancellationPolicy: (recruitmentId: string) => `/recruitments/${recruitmentId}/check/cancel_policy`,
      rulesAndManners: (recruitmentId: string) => `/recruitments/${recruitmentId}/check/rules_and_manners`,
      licenses: (recruitmentId: string) => `/recruitments/${recruitmentId}/check/licenses`,
      documents: (recruitmentId: string) => `/recruitments/${recruitmentId}/check/documents`,
    },
  },
  reviews: {
    requests: {
      form: '/reviews/requests/form',
    },
  },
  privacy: '/privacy',
  terms: '/terms',
  cancellationPolicy: '/cancellation_policy',
} as const;
